<template>
    <div v-if="msgAlerta" class="info-alert row-space clickable" @click="msgAlerta=null"><span class="text">{{ msgAlerta }}</span></div>

    <div v-if="statusTela===0" class="form-edit-page">
        <div class="row row-space">
            <div class="form-item-char05">
                <label class="label-caption">Código</label>
                <div class="field-label field-label-end">{{ Funcoes.formatInteger(objEdicao.id) }}</div>
            </div>

            <div class="form-item-char15">
                <label class="label-caption">Código Processo</label>
                <input type="text" v-model="objEdicao.cdprocesso" maxlength="30" />
            </div>

            <div class="form-item">
                <label class="label-caption">Nome Processo</label>
                <input type="text" v-model="objEdicao.nmprocesso" maxlength="100" />
            </div>

            <div class="form-item-char15">
                <label class="label-caption">Ativo</label>
                <select v-model="objEdicao.ativo">
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                </select>
            </div>
        </div>        


        <div class="row row-space">
            <div class="form-item">
                <EpMenuProcSelect v-model:idSelecionado="objEdicao.idepmenuproc"></EpMenuProcSelect>
            </div>

            <div class="form-item-char15">
                <label class="label-caption">S.I.M.</label>
                <select v-model="objEdicao.cksim">
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                </select>
            </div>

            <div class="form-item-char15">
                <label class="label-caption">Estabelecimento</label>
                <select v-model="objEdicao.ckestabelecimento">
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                </select>
            </div>

            <div class="form-item-char15">
                <label class="label-caption">Produto</label>
                <select v-model="objEdicao.ckproduto">
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                </select>
            </div>

            <div class="form-item-char15">
                <label class="label-caption">Rótulo</label>
                <select v-model="objEdicao.ckrotulo">
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                </select>
            </div>
        </div>


        <div class="row row-space">
            <div class="form-item">
                <textarea
                    v-model="objEdicao.descricao"
                    id="informacoes"
                    maxlength="3000"
                    rows="3"
                    style="resize: none;"
                />
            </div>
        </div>


        <div class="row-end">
            <button type="button" class="btn-cancel" @click="closeForm">Cancelar</button>
            <button type="button" class="btn-confirm" @click="salvarCabecalho">Salvar</button>
        </div>
    </div>


    <div v-else>
        <div class="form-edit-page row-space">
            <div class="row row-space">
                <div class="form-item-char05">
                    <label class="label-caption">Código</label>
                    <div class="field-label field-label-end">{{ Funcoes.formatInteger(objView.id) }}</div>
                </div>
                
                <div class="form-item-char15">
                    <label class="label-caption">Código Processo</label>
                    <div class="field-label field-label-center">{{ objView.cdprocesso }}</div>
                </div>
                
                <div class="form-item">
                    <label class="label-caption">Nome Processo</label>
                    <div class="field-label">{{ objView.nmprocesso }}</div>
                </div>
            </div>

            <div class="row-end">
                <button class="btn-small" @click="modoEtapa=true; modoItem=false; modoParametrizacao=false;">Etapas</button>
                <button class="btn-small" @click="modoEtapa=false; modoItem=true; modoParametrizacao=false;">Ítens</button>
                <button class="btn-small" @click="modoEtapa=false; modoItem=false; modoParametrizacao=true;">Configuração</button>
                <button class="btn-small" @click="closeForm">Voltar</button>
            </div>
        </div>


        <div v-if="modoEtapa">
            <div v-if="lsEtapas.length>0" class="table-wrapper row-space"><table>
                <thead><tr>
                    <th>ETAPA</th>
                    <th>Ordem</th>
                    <th>Nome</th>
                </tr></thead>
                
                <tbody><tr v-for="(obj, index) in lsEtapas" :key="obj.id" @click="editarEtapa(obj)" 
                    :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}">
                        <td class="col-width-char20 center">{{ obj.cdetapa }}</td>
                        <td class="col-width-char10 center">{{ obj.ordem }}</td>
                        <td>{{ obj.nmetapa }}</td>
                </tr></tbody>
            </table></div>

            <div class="form-panel row-space">
                <div class="form-panel-header">ETAPA DO PROCESSO</div>
                <div class="form-panel-body">
                    <div class="row row-space">
                        <div class="form-item-char05">
                            <label class="label-caption">Código</label>
                            <div class="field-label field-label-end">{{ Funcoes.formatInteger(objEtapa.id) }}</div>
                        </div>

                        <div class="form-item-char15">
                            <label class="label-caption">Ordem</label>
                            <input type="number" v-model="objEtapa.ordem" maxlength="4" />
                        </div>

                        <div class="form-item-char15">
                            <label class="label-caption">Código Etapa</label>
                            <input type="text" v-model="objEtapa.cdetapa" maxlength="30" v-uppercase />
                        </div>

                        <div class="form-item">
                            <label class="label-caption">Nome Etapa</label>
                            <input type="text" v-model="objEtapa.nmetapa" maxlength="100" />
                        </div>

                        <div class="form-item-char15">
                            <label class="label-caption">Prazo</label>
                            <input type="number" v-model="objEtapa.pzdias" maxlength="3" />
                        </div>

                        <div class="form-item-char15">
                            <label class="label-caption">Inicial</label>
                            <select v-model="objEtapa.ckinicial">
                                <option value="S">Sim</option>
                                <option value="N">Não</option>
                            </select>
                        </div>

                        <div class="form-item-char15">
                            <label class="label-caption">Final</label>
                            <select v-model="objEtapa.ckfinal">
                                <option value="S">Sim</option>
                                <option value="N">Não</option>
                            </select>
                        </div>
                    </div>


                    <div class="row row-space">
                        <div class="form-item">
                            <label class="label-caption">Etapa ao Reprovar</label>
                            <select v-model.number="objEtapa.idetapa_retorno1">
                                <option :value="0">Nenhuma</option>
                                <option
                                    v-for="e in lsEtapas"
                                    :key="`reprov1-${e.id}`"
                                    :value="e.id"
                                >
                                    {{ e.ordem }} - {{ e.nmetapa }}
                                </option>
                            </select>
                        </div>
                        
                        <div class="form-item">
                            <label class="label-caption">Etapa ao Aprovar</label>
                            <select v-model.number="objEtapa.idetapa_avanco1">
                                <option :value="0">Nenhuma</option>
                                <option
                                    v-for="e in lsEtapas"
                                    :key="`aprov1-${e.id}`"
                                    :value="e.id"
                                >
                                    {{ e.ordem }} - {{ e.nmetapa }}
                                </option>
                            </select>
                        </div>
                    </div>


                    <div class="row row-space">
                        <div class="form-item">
                            <select v-model.number="objEtapa.idetapa_retorno2">
                                <option :value="0">Nenhuma</option>
                                <option
                                    v-for="e in lsEtapas"
                                    :key="`reprov2-${e.id}`"
                                    :value="e.id"
                                >
                                    {{ e.ordem }} - {{ e.nmetapa }}
                                </option>
                            </select>
                        </div>
                        
                        <div class="form-item">
                            <select v-model.number="objEtapa.idetapa_avanco2">
                                <option :value="0">Nenhuma</option>
                                <option
                                    v-for="e in lsEtapas"
                                    :key="`aprov2-${e.id}`"
                                    :value="e.id"
                                >
                                    {{ e.ordem }} - {{ e.nmetapa }}
                                </option>
                            </select>
                        </div>
                    </div>


                    <div class="row row-space">
                        <div class="form-item">
                            <textarea
                                v-model="objEtapa.descricao"
                                id="informacoes"
                                maxlength="3000"
                                rows="2"
                                style="resize: none;"
                            />
                        </div>
                    </div>

                    <div class="row-end">
                        <button class="btn-small btn-delete">Excluir</button>
                        <button class="btn-small btn-cancel">Cancelar</button>
                        <button class="btn-small" @click="salvarEtapa">Salvar</button>
                    </div>
                </div>
            </div>
        </div>


        <div v-show="modoItem">
            <div v-if="lsItens.length>0" class="table-wrapper row-space"><table>
                <thead><tr>
                    <th>ÍTEM</th>
                    <th>Nome</th>
                    <th>Origem</th>
                    <th>Referência</th>
                </tr></thead>
                
                <tbody><tr v-for="(obj, index) in lsItens" :key="obj.id" @click="editarItem(obj)" 
                    :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}">
                        <td class="col-width-char20 center">{{ obj.cditem }}</td>
                        <td>{{ obj.nmitem }}</td>
                        <td  class="col-width-char15 center">{{ obj.nmorigem }}</td>
                        <td>{{ obj.nmepdocmodelo }}{{ obj.nmtpdoc }}</td>
                </tr></tbody>
            </table></div>


            <div class="form-panel">
                <div class="form-panel-header">ÍTEM DO PROCESSO</div>
                <div class="form-panel-body">
                    <div class="row row-space">
                        <div class="form-item-char05">
                            <label class="label-caption">Código</label>
                            <div class="field-label field-label-end">{{ Funcoes.formatInteger(objItem.id) }}</div>
                        </div>

                        <div class="form-item-char15">
                            <label class="label-caption">Código Ítem</label>
                            <input type="text" v-model="objItem.cditem" maxlength="30" v-uppercase />
                        </div>

                        <div class="form-item">
                            <label class="label-caption">Nome Ítem</label>
                            <input type="text" v-model="objItem.nmitem" maxlength="100" />
                        </div>
                    </div>


                    <div class="row row-space">
                        <div class="form-item">
                            <EpDocModeloSelect v-model:idSelecionado="objItem.idepdocmodelo"></EpDocModeloSelect>
                        </div>

                        <div class="form-item">
                            <TpDocSelect v-model:idSelecionado="objItem.idtpdoc"></TpDocSelect>
                        </div>
                    </div>


                    <div class="row row-space">
                        <div class="form-item">
                            <textarea
                                v-model="objItem.descricao"
                                id="informacoes"
                                maxlength="3000"
                                rows="2"
                                style="resize: none;"
                            />
                        </div>
                    </div>

                    <div class="row-end">
                        <button class="btn-small btn-delete">Excluir</button>
                        <button class="btn-small btn-cancel">Cancelar</button>
                        <button class="btn-small" @click="salvarItem">Salvar</button>
                    </div>
                </div>
            </div>
        </div>



        <div v-show="modoParametrizacao">
            <div v-if="lsEtapas.length > 0" class="row row-space">
                <div class="form-item">
                    <select id="etapaSelect" v-model="etapaSelecionada" @change="setEtapaParametrizar(etapaSelecionada)">
                        <option v-for="obj in lsEtapas" :key="obj.id" :value="obj">
                            {{ obj.cdetapa }} - {{ obj.ordem }} - {{ obj.nmetapa }}
                        </option>
                    </select>
                </div>

                <button class="btn-small" @click="salvarParametros">Salvar</button>
            </div>


            <div v-if="lsEtapaItem.length > 0" class="table-card">
                <table>
                    <thead>
                        <tr>
                            <th>Origem - Item</th>
                            <th>Ativo/Vinculado</th>
                            <th>Obrigatório</th>
                            <th>Permite múltiplos</th>
                            <th>Exige análise</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in lsEtapaItem" :key="item.id">
                            <td class="perfil-col">{{ item.nmorigem }} - {{ item.nmitem }}</td>
                            <td class="col-width-char20"><input type="checkbox" v-model="item.ativo" true-value="S" false-value="N" /></td>
                            <td class="col-width-char20"><input type="checkbox" v-model="item.ckobrigatorio" true-value="S" false-value="N" /></td>
                            <td class="col-width-char20"><input type="checkbox" v-model="item.ckpermite_multiplos" true-value="S" false-value="N" /></td>
                            <td class="col-width-char20"><input type="checkbox" v-model="item.ckexige_analise" true-value="S" false-value="N" /></td>
                        </tr>
                    </tbody>
                </table>
            </div>



            <div v-if="lsEtapaPerfil.length > 0" class="table-card">
                <table>
                    <thead>
                        <tr>
                            <th>Perfil</th>
                            <th>Consultar</th>
                            <th>Adicionar anexo</th>
                            <th>Adicionar documento</th>
                            <th>Análise item</th>
                            <th>Avançar</th>
                            <th>Retornar</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="perfil in lsEtapaPerfil" :key="perfil.id">
                            <td class="perfil-col">{{ perfil.nmperfil }}</td>
                            <td class="col-width-char20"><input type="checkbox" v-model="perfil.ckconsultar" true-value="S" false-value="N" /></td>
                            <td class="col-width-char20"><input type="checkbox" v-model="perfil.ckadd_anexo" true-value="S" false-value="N" /></td>
                            <td class="col-width-char20"><input type="checkbox" v-model="perfil.ckadd_doc" true-value="S" false-value="N" /></td>
                            <td class="col-width-char20"><input type="checkbox" v-model="perfil.ckanalise_item" true-value="S" false-value="N" /></td>
                            <td class="col-width-char20"><input type="checkbox" v-model="perfil.ckavancar" true-value="S" false-value="N" /></td>
                            <td class="col-width-char20"><input type="checkbox" v-model="perfil.ckretornar" true-value="S" false-value="N" /></td>
                        </tr>
                    </tbody>
                </table>
            </div>


        </div>
    </div>
</template>


<script setup>
import { onMounted, ref, watch } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { criarEpProc } from '@/models/epProc';
import { criarEpProcEtapa } from '@/models/epProcEtapa';
import { criarEpProcItem } from '@/models/epProcItem';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import { Validar } from '@/funcoes/validacoes';
import EpDocModeloSelect from '@/components/selects/EpDocModeloSelect.vue';
import EpMenuProcSelect from '@/components/selects/EpMenuProcSelect.vue';
import TpDocSelect from '@/components/selects/TpDocSelect.vue';


const emit = defineEmits(['close', 'save']);
const props = defineProps({
    idEdicao: {
        type: Number,
        default: 0
    }
});


const modoEtapa = ref(false);
const modoItem = ref(false);
const modoParametrizacao = ref(false);


const lsEtapaItem = ref([]);
const lsEtapaPerfil = ref([]);


const ckEmitSave = ref(false);
const isLoading = ref(false);
const msgAlerta=ref(null);
const statusTela=ref(0);

const lsEtapas=ref([]);
const lsItens=ref([]);
const objEdicao = ref(criarEpProc());
const objEtapa = ref(criarEpProcEtapa());
const objEtapaConfig = ref({});
const objItem = ref(criarEpProcItem());
const objView = ref({});

function closeForm(){
    if (ckEmitSave.value) emit('save');
    emit('close');
}


async function editarEtapa(obj){
    try{
        const r = await Api.getCadastroById('epproc_etapa', obj.id);
        Object.assign(objEtapa.value, r[0]);
    }catch(e){msgAlerta.value=e;}
}


async function editarItem(obj){
    try{
        const r = await Api.getCadastroById('epproc_item', obj.id);
        Object.assign(objItem.value, r[0]);
    }catch(e){msgAlerta.value=e;}
}


async function lerDados() {
    try {
        isLoading.value = true;
        msgAlerta.value = null;

        if (props.idEdicao > 0) {
            const req = await Api.getCadastroById('epproc', props.idEdicao);
            Object.assign(objEdicao.value, req[0]);
        } else {
            objEdicao.value.idep = globalStore.idep;
        }

        objEdicao.value.idlogin = globalStore.idlogin;

    } catch (error) {
        msgAlerta.value = `ATENÇÃO: Não foi possível acessar dados do servidor: "${error.message}"`;
    } finally {
        isLoading.value = false;
    }
}


async function lerEtapas(){
    try{
        const req = await Api.genericPost('/listas/epproc_etapa', {
            idep: globalStore.idep,
            idreferencia: objEdicao.value.id
        });
        lsEtapas.value = req;
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    }
}


async function lerItens(){
    try{
        const req = await Api.genericPost('/listas/epproc_item', {
            idep: globalStore.idep,
            idreferencia: objEdicao.value.id
        });
        lsItens.value = req;
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    }
}


async function salvarCabecalho(){
    let x = "";
    let r = Validar.texto(objEdicao.value.cdprocesso, 'Informe o código do modelo de processo');
    if (!r.ok) x += `\n-${r.msg}`;
    r = Validar.texto(objEdicao.value.nmprocesso, 'Informe o nome do modelo de processo');
    if (!r.ok) x += `\n-${r.msg}`;
    if (x){msgAlerta.value=`ATENÇÃO:${x}`; return}    

    try {
        isLoading.value = true;
        const response = await Api.genericPut('/cad/epproc', objEdicao.value);

        if (response.bolok === 1) {
            ckEmitSave.value=true;
            const req = await Api.genericPost('/listas/epproc', {idep: globalStore.idep, id: response.id});
            Object.assign(objView.value, req[0]);

            await lerEtapas();
            await lerItens();

            statusTela.value=1;
            // closeForm();
        } else {
            msgAlerta.value = response.erro;
        }
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}


async function salvarEtapa(){
    let x = "";
    let r = Validar.texto(objEtapa.value.cdetapa, 'Informe o código da etapa');
    if (!r.ok) x += `\n-${r.msg}`;
    r = Validar.texto(objEtapa.value.nmetapa, 'Informe o nome da etapa');
    if (!r.ok) x += `\n-${r.msg}`;
    if (x){msgAlerta.value=`ATENÇÃO:${x}`; return}    

    try {
        isLoading.value = true;
        objEtapa.value.idepproc = objView.value.id;
        objEtapa.value.idlogin = globalStore.idlogin;

        const response = await Api.genericPut('/cad/epproc_etapa', objEtapa.value);

        if (response.bolok === 1) {
            await lerEtapas();
            objEtapa.value = criarEpProcEtapa();
        } else {
            msgAlerta.value = response.erro;
        }
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}


async function salvarItem(){
    let x = "";
    let r = Validar.texto(objItem.value.cditem, 'Informe o código do ítem');
    if (!r.ok) x += `\n-${r.msg}`;
    r = Validar.texto(objItem.value.nmitem, 'Informe o nome do item');
    if (!r.ok) x += `\n-${r.msg}`;
    if (!objItem.value.idepdocmodelo && !objItem.value.idtpdoc) x+='\n-Informe modelo de formulário ou tipo de documento';
    if (objItem.value.idepdocmodelo && objItem.value.idtpdoc) x+='\n-Informe somente modelo de formulário ou tipo de documento';
    if (x){msgAlerta.value=`ATENÇÃO:${x}`; return}    

    try {
        isLoading.value = true;
        objItem.value.idepproc = objView.value.id;
        objItem.value.idlogin = globalStore.idlogin;
        objItem.value.tporigem = (objItem.value.idtpdoc) ? 1 : 2;

        const response = await Api.genericPut('/cad/epproc_item', objItem.value);

        if (response.bolok === 1) {
            await lerItens();
            objItem.value = criarEpProcItem();
        } else {
            msgAlerta.value = response.erro;
        }
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}


async function salvarParametros(){
    if (!objEtapaConfig.value) return;
    try{
        for (const item of lsEtapaItem.value){
            const temPermissao = (
                item.ativo === 'S' ||
                item.ckobrigatorio === 'S' ||
                item.ckpermite_multiplos === 'S' ||
                item.ckexige_analise === 'S'
            );
            const jaPossuiVinculo = Number(item.idepproc_etapa || 0) > 0;
            
            if (temPermissao){
                await Api.genericPut('/cad/epproc_etapaitem',{
                    idepproc_etapa: objEtapaConfig.value.id,
                    idepproc_item: item.id,
                    ativo: item.ativo,
                    ckobrigatorio: item.ckobrigatorio,
                    ckpermite_multiplos: item.ckpermite_multiplos,
                    ckexige_analise: item.ckexige_analise,
                    idlogin: globalStore.idlogin,
                });
            } else if (jaPossuiVinculo) {
                await Api.genericPost('/cad/exec_requisicao', {
                    nmrequisicao: "revogar_epproc_etapaitem",
                    intparam1: objEtapaConfig.value.id,
                    intparam2: item.id,
                    idlogin: globalStore.idlogin
                });
            }
        }


        for (const perfil of lsEtapaPerfil.value){
            const temPermissao = (
                perfil.ckconsultar === 'S' ||
                perfil.ckinserir_dados === 'S' ||
                perfil.ckanalise_documentos === 'S' ||
                perfil.ckanexar_doc === 'S' ||
                perfil.ckavancar === 'S' ||
                perfil.ckretornar === 'S'
            );

            const jaPossuiVinculo = Number(perfil.idepproc_etapa || 0) > 0;
            
            if (temPermissao){
                await Api.genericPut('/cad/epproc_etapaperfil',{
                    idepproc_etapa: objEtapaConfig.value.id,
                    idusuario_perfil: perfil.id,
                    ckadd_anexo: perfil.ckadd_anexo,
                    ckadd_doc: perfil.ckadd_doc,
                    ckanalise_item: perfil.ckanalise_item,
                    ckavancar: perfil.ckavancar,
                    ckconsultar: perfil.ckconsultar,
                    ckretornar: perfil.ckretornar,
                    idlogin: globalStore.idlogin,
                });
            } else if (jaPossuiVinculo) {
                await Api.genericPost('/cad/exec_requisicao', {
                    nmrequisicao: "revogar_epproc_etapaperfil",
                    intparam1: objEtapaConfig.value.id,
                    intparam2: perfil.id,
                    idlogin: globalStore.idlogin
                });
            }
        }
    }catch(e){msgAlerta.value=e;}
}


async function setEtapaParametrizar(obj){
    try{
        objEtapaConfig.value = obj;
        const ri = await Api.genericPost('/listas/epproc_etapa/config/itens', {id: obj.id, idreferencia: objView.value.id});
        lsEtapaItem.value = ri;

        const rp = await Api.genericPost('/listas/epproc_etapa/config/perfil', {id: obj.id, idep: globalStore.idep});
        lsEtapaPerfil.value = rp;
    }catch(e){msgAlerta.value=e;}
    console.log(obj);
}



watch(() => objItem.value.idepdocmodelo, (novoValor) => {
  if (novoValor) {
    objItem.value.idtpdoc = 0
  }
})

watch(() => objItem.value.idtpdoc, (novoValor) => {
  if (novoValor) {
    objItem.value.idepdocmodelo = 0
  }
})


onMounted(lerDados)
</script>


<style scoped>
.table-card {
  border: 1px solid #ddd;
  border-radius: 6px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.08);
  margin-bottom: 16px;
}

.table-card table {
  width: 100%;
  border-collapse: collapse;
}

.table-card th {
  background: #f5f5f5;
  font-size: 13px;
  font-weight: 600;
  color: #333;
  padding: 8px;
  text-align: center;
}

.table-card td {
  text-align: center;
  padding: 6px;
  border-top: 1px solid #eee;
}

.table-card .perfil-col {
  text-align: left;
  font-weight: 500;
  color: #444;
}

.table-card input[type="checkbox"] {
  transform: scale(0.7);
  accent-color: #0078d7; /* azul estilo Microsoft */
  margin: 0;
}

</style>